export class TenantLeaseType {
  static readonly LCD = "lcd";
  static readonly NU = "nu";
  static readonly MEUBLE = "meuble";
  static readonly COMMERCIAL = "commercial";
  static readonly GARAGE = "garage";
  static readonly HABITATION = "habitation";
  static readonly MOBILITE = "mobilite";
  static readonly PROFESSIONNEL = "professionnel";
  static readonly ETUDIANT = "etudiant";
  static readonly COMMERCIAL_DEROGATOIRE = "commercial_derogatoire";
  static readonly SOUS_LOCATION = "sous-location";
  static readonly CIVIL_HABITATION = "civil_habitation";
  static readonly CIVIL = "civil";
  static readonly STOCKAGE = "stockage";
  static readonly PARKING = "parking";

  static isHabitation(leaseType: string | undefined) {
    return [
      TenantLeaseType.NU,
      TenantLeaseType.ETUDIANT,
      TenantLeaseType.MEUBLE,
      TenantLeaseType.MOBILITE,
    ].includes(leaseType as TenantLeaseTypeValue);
  }
  static isAutreLocal(leaseType: string | undefined) {
    return [
      TenantLeaseType.PARKING,
      TenantLeaseType.STOCKAGE,
      TenantLeaseType.CIVIL,
      TenantLeaseType.CIVIL_HABITATION,
      TenantLeaseType.LCD,
      TenantLeaseType.SOUS_LOCATION,
    ].includes(leaseType as TenantLeaseTypeValue);
  }
  static isCommercial(leaseType: string | undefined) {
    return [
      TenantLeaseType.COMMERCIAL,
      TenantLeaseType.COMMERCIAL_DEROGATOIRE,
      TenantLeaseType.PROFESSIONNEL,
    ].includes(leaseType as TenantLeaseTypeValue);
  }
}

type TenantLeaseTypeValue =
  | typeof TenantLeaseType.LCD
  | typeof TenantLeaseType.NU
  | typeof TenantLeaseType.MEUBLE
  | typeof TenantLeaseType.COMMERCIAL
  | typeof TenantLeaseType.GARAGE
  | typeof TenantLeaseType.HABITATION
  | typeof TenantLeaseType.MOBILITE
  | typeof TenantLeaseType.PROFESSIONNEL
  | typeof TenantLeaseType.ETUDIANT
  | typeof TenantLeaseType.COMMERCIAL_DEROGATOIRE
  | typeof TenantLeaseType.SOUS_LOCATION
  | typeof TenantLeaseType.CIVIL_HABITATION
  | typeof TenantLeaseType.CIVIL
  | typeof TenantLeaseType.STOCKAGE
  | typeof TenantLeaseType.PARKING;

export class LeaseKind {
  static readonly HABITATION = "habitation";
  static readonly COMMERCIAL = "commercial";
  static readonly CIVIL = "civil";
}

export type LeaseKindValue =
  | typeof LeaseKind.HABITATION
  | typeof LeaseKind.COMMERCIAL
  | typeof LeaseKind.CIVIL;

// Famille juridique de chaque type de bail, telle que le catalogue `/balance-types` la
// compare (`lease_kinds`). Miroir de `TenantLeaseType.kind` côté back.
export const LEASE_KIND_BY_LEASE_TYPE: Record<string, LeaseKindValue> = {
  [TenantLeaseType.NU]: LeaseKind.HABITATION,
  [TenantLeaseType.MEUBLE]: LeaseKind.HABITATION,
  [TenantLeaseType.ETUDIANT]: LeaseKind.HABITATION,
  [TenantLeaseType.MOBILITE]: LeaseKind.HABITATION,
  [TenantLeaseType.HABITATION]: LeaseKind.HABITATION,
  [TenantLeaseType.LCD]: LeaseKind.HABITATION,
  [TenantLeaseType.SOUS_LOCATION]: LeaseKind.HABITATION,
  [TenantLeaseType.COMMERCIAL]: LeaseKind.COMMERCIAL,
  [TenantLeaseType.COMMERCIAL_DEROGATOIRE]: LeaseKind.COMMERCIAL,
  [TenantLeaseType.PROFESSIONNEL]: LeaseKind.COMMERCIAL,
  [TenantLeaseType.CIVIL]: LeaseKind.CIVIL,
  [TenantLeaseType.CIVIL_HABITATION]: LeaseKind.CIVIL,
  [TenantLeaseType.GARAGE]: LeaseKind.CIVIL,
  [TenantLeaseType.PARKING]: LeaseKind.CIVIL,
  [TenantLeaseType.STOCKAGE]: LeaseKind.CIVIL,
};

export function leaseKindOf(leaseType: string | null | undefined) {
  return leaseType ? LEASE_KIND_BY_LEASE_TYPE[leaseType] : undefined;
}

export class ChargesType {
  static readonly PROVISION = "provision";
  static readonly FORFAIT = "forfait";
}

/**
 * Baux où le bailleur choisit entre provision et forfait de charges : meublé,
 * famille civile (civil, garage, parking, stockage…) et colocation collective nue.
 * Le bail nu classique impose la provision.
 */
export function allowsChargesForfait(leaseTemplate: {
  type?: string | null;
  colocation?: boolean;
  collectif?: boolean;
}) {
  return (
    leaseTemplate.type === TenantLeaseType.MEUBLE ||
    leaseKindOf(leaseTemplate.type) === LeaseKind.CIVIL ||
    (leaseTemplate.type === TenantLeaseType.NU &&
      !!leaseTemplate.colocation &&
      !!leaseTemplate.collectif)
  );
}

export class AutreAppelCategorie {
  static readonly AUTRE_CHARGE = "autre_charge";
  static readonly TAXE_FONCIERE = "taxe_fonciere";
  static readonly TOEM = "toem";
}

export type AutreAppelCategorieValue =
  | typeof AutreAppelCategorie.AUTRE_CHARGE
  | typeof AutreAppelCategorie.TAXE_FONCIERE
  | typeof AutreAppelCategorie.TOEM;
